/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppRole } from './AppRole';
import {
    AppRoleFromJSON,
    AppRoleFromJSONTyped,
    AppRoleToJSON,
    AppRoleToJSONTyped,
} from './AppRole';

/**
 * 
 * @export
 * @interface UserPermissionsDto
 */
export interface UserPermissionsDto {
    /**
     * 
     * @type {boolean}
     * @memberof UserPermissionsDto
     */
    isPermissionAdmin: boolean;
    /**
     * 
     * @type {Array<AppRole>}
     * @memberof UserPermissionsDto
     */
    roles: Array<AppRole>;
}

/**
 * Check if a given object implements the UserPermissionsDto interface.
 */
export function instanceOfUserPermissionsDto(value: object): value is UserPermissionsDto {
    if (!('isPermissionAdmin' in value) || value['isPermissionAdmin'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function UserPermissionsDtoFromJSON(json: any): UserPermissionsDto {
    return UserPermissionsDtoFromJSONTyped(json, false);
}

export function UserPermissionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPermissionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isPermissionAdmin': json['isPermissionAdmin'],
        'roles': ((json['roles'] as Array<any>).map(AppRoleFromJSON)),
    };
}

export function UserPermissionsDtoToJSON(json: any): UserPermissionsDto {
    return UserPermissionsDtoToJSONTyped(json, false);
}

export function UserPermissionsDtoToJSONTyped(value?: UserPermissionsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isPermissionAdmin': value['isPermissionAdmin'],
        'roles': ((value['roles'] as Array<any>).map(AppRoleToJSON)),
    };
}

